export const iconFontAwesomeMathematicsCirclePlus = (
	<i className="fa-solid fa-circle-plus"></i>
);
